// get the Prefix for API calls
let APIPrefix = {
    APIUrl: '',
    initialised: false,
    init: function() {
        this.initialised = true;
    },
    get: function() {
        if(!this.initialised) {
            this.init();
        }
        return this.APIUrl;
    }
};


function visuallyHiddenText(text) {
    return `<span class="visually-hidden">${text}</span>`;
}

let APIUtils = (function () {
    let API_LOGIN_REQUEST = '/api/signin';
    let initialised = false;
    let loadTransition = {};
    let loadMsg = {};
    let loadWrap = {};

    const init = function (loaderType, targetType) {
        // Loading message and icon to display when getting data from API
        if (loaderType === "spinner") {
            loadTransition = document.createElement('div');
            loadTransition.classList = 'list-loader';
            loadMsg = document.createElement('p');
            if(targetType === 'UL') {
                loadWrap = document.createElement('li');
            } else {
                loadWrap = document.createElement('div');
            }
            loadWrap.classList = 'loader-wrapper';
            loadWrap.appendChild(loadTransition);
            loadWrap.appendChild(loadMsg);
        } else {
            loadTransition = document.createElement('div');
            loadTransition.classList = 'loader-wrapper empty';
            loadWrap = document.createElement('li');
            loadWrap.classList = 'loader-wrapper';
            loadWrap.appendChild(loadTransition);
            loadTransition.insertAdjacentHTML('beforeend', `<p></p>`);
            loadMsg = loadTransition.querySelector('p');
        }

        initialised = true;
    };

    const redirectUserToSigninPage = function() {
        if (!initialised) {
            init();
        }

        window.location.pathname = API_LOGIN_REQUEST;
    };

    // get data without populating a component
    const getData = async function (URL) {
        if (!initialised) {
            init();
        }

        let response = await fetch(URL);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    
        return await response.json();
    };

    const getComponentData = async function (component, URL, successMessage, errorMessage, loaderType = "spinner") {
        if (!initialised) {
            let componentElementType = component.nodeName;
            init(loaderType, componentElementType);
        }

        loadMsg.innerText = successMessage;
        loadMsg.classList = 'loader-title';
        component.appendChild(loadWrap);
        let response = await fetch(URL);
        if (!response.ok) {
            loadMsg.innerText = errorMessage;
            loadMsg.classList = 'error-title';
            component.removeChild(loadWrap);
            component.appendChild(loadMsg);
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    
        component.removeChild(loadWrap);
        return await response.json();
    };

return {
    init: init,
    getData: getData,
    getComponentData: getComponentData,
    redirectUserToSigninPage : redirectUserToSigninPage
};

})();